import styled from 'styled-components';
import {
  customScrollbar,
} from 'cdk-radial';
import { IconInfo,IconStatusInformationI,IconStatusInformationTrendUp} from 'cdk-radial';

export const StyledOutageNotificationContainer = styled.div`
  margin-top: 0px;
  max-width: 1280px;
  @media (max-width: 1280px) {
    max-width: -webkit-fill-available;
  }
  @media (max-width: 470px) {
    max-width: 99%;
  }
`;

export const StyledContentContainer = styled.div`
  ${customScrollbar};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
`;

export const StyledOutageNotificationContainerSpacer = styled.div`
  background: rgb(254, 240, 220);
  width: 100vw;
  height: min-content;
  display: flex;
`;

export const StyledWorkflowContainer = styled.div<{
  isHome: boolean;
  height?: string;
}>`
  height: ${({ isHome, height }) =>
    isHome ? 'auto' : height || '0px'};
  overflow: ${({ isHome }) => (isHome ? 'auto' : 'hidden')};
  transition: border-color 1s ease-out;
  @media (max-width: 470px) {
    width: 90vw;
  }
  @media (max-width: 390px) {
  }
`;

export const AppContainerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px 8px;
  font-weight: 600;
  font-size: 15px;
`;


export const ApplicationContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  @media (min-width: 1440px) {
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  }
`;

export const ApplicationCard = styled.div`
  background: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#F2F2F2')};
  backdrop-filter: blur(3px);
  border: 1px solid ${({ theme }) => (theme.darkMode ? '#333333' : '#e6e6e6')};
  border-radius: ${({ theme }) => theme.carbon.element.card.border.radius};
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-height: 250px;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 16px;
  padding-left: 16px;

  :hover{
    background: ${({ theme }) => (theme.darkMode ? '#333333' : '#E6E6E6')};
    border: 1px solid ${({ theme }) => (theme.darkMode ? '#4D4D4D' : '#CCCCCC')};
    cursor: pointer;
    [data-id="icon-card-more"] {
      display: block;
    }
  }
  :active {
    border: 1px solid ${({ theme }) => (theme.darkMode ? '#666666' : '#B3B3B3')};
  }
  :focus-visible,
  :focus-within {
    background: ${({ theme }) => (theme.darkMode ? '#333333' : '#E6E6E6')};
    border: 1px solid ${({ theme }) => (theme.darkMode ? '#4D4D4D' : '#CCCCCC')};
    box-shadow: 0px 0px 0px 4px
      ${({ theme }) =>
    theme.darkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'};
    outline: none;
    [data-id="icon-card-more"] {
       display: block;
    }
  }
  @media (max-width: 470px) {
    width:80vw;
  }
  @media (max-width: 450px) {
    width:82vw;
  }
  @media (max-width: 390px) {
    width:315px;
    [data-id="icon-card-more"] {
      display: block
    }
  }
  @media (max-width: 1024px) {
    [data-id="icon-card-more"] {
      display: block
    }
  }
`;


export const App = styled.div`
  font-family: Roboto, Montserrat, sans-serif;
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 5px;
  flex-direction: row;
`;

export const AppIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #013047;
  font-size: 12px;
  color: #fff;
  padding-bottom: 0;
  margin-right: 6px;
`

export const AppFrame = styled.div`
  border: '1px solid #dadada';
  width: 100%;
  padding: 2px;
`;



// The black "track"
export const TabContainer = styled.div`
  display: inline-flex;
  background-color: #000;
  border-radius: 100px;
  padding: 2px;
  gap: 2px;
`;

interface TabButtonProps {
  $isActive: boolean;
}

export const TabButton = styled.button<TabButtonProps>`
  border: none;
  cursor: pointer;
  font-family: Roboto, Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 24px;
  border-radius: 100px;
  transition: all 0.2s ease-in-out;

  /* Switch colors based on state */
  background-color: ${(props:any) => (props.$isActive ? '#fff' : 'transparent')};
  color: ${(props:any) => (props.$isActive ? '#000' : '#fff')};

  &:hover {
    background-color: ${(props:any) => (props.$isActive ? '#fff' : 'rgba(255,255,255,0.1)')};
  }
`;

export const DriveWarning = styled.div`
  font-family: Montserrat, Roboto, sans-serif;
    -webkit-box-align: center;
    align-items: center;
    color: rgb(125, 78, 12);
    display: flex;
    font-size: 12px;
    font-weight: 500;
    margin-top: 5px;
    margin-bottom: 5px;
  `;

export const WarningIcon = styled(IconInfo)`
  fill:  ${({ theme }) => theme.carbon.color.warning};
  height: 16px;
  width: 16px;
  padding-right: 2px;
`;

export const IconStatusInformationIcon = styled(IconStatusInformationI)`
  margin-top: 5px;
  fill: #E6C19B;
  padding-right: 2px;
`;

export const IconStatusInformationTrendUpIcon = styled(IconStatusInformationTrendUp)`
  margin-top: 5px;
  fill: #E6C19B;
  padding-right: 2px;
`;


export const StyledOutageNotificationText = styled.div`
    margin-left: 35px;
    display: -webkit-box; 
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;
    overflow: hidden; 
    text-overflow: ellipsis;
`

export const StyledAlertTitle = styled.div`
    font-family: Roboto, Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 5px;
    margin-bottom: -5px;
`